/**
 * Web: ask for browser Notification permission only from a high-intent gesture.
 */
import {
  hasLocalNotificationPermission,
  requestLocalNotificationPermission,
} from './localPushNotification';

let inFlight: Promise<boolean> | null = null;

export function requestNotificationsOnUserGesture(): Promise<boolean> {
  if (inFlight) return inFlight;
  inFlight = (async () => {
    if (await hasLocalNotificationPermission()) return true;
    return requestLocalNotificationPermission();
  })().finally(() => {
    inFlight = null;
  });
  return inFlight;
}

export async function registerFcmTokenIfAlreadyAuthorized(): Promise<void> {
  // no-op on web
}

export async function ensureDefaultNotificationChannel(): Promise<void> {
  // no-op on web
}
